import { renderTableTitle } from "@/utils/render.jsx";
import request from "@/service/invites";
import TextMasker from "@/components/Common/text-masker.vue";
import TextEllipsis from "@/components/Common/text-ellipsis.vue";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
export default {
  name: "ApplyRecord",
  // eslint-disable-next-line vue/no-unused-components
  components: {
    TextMasker,
    TextEllipsis
  },
  data() {
    return {
      tableRef: null,
      datas: [],
      inviteCode: null,
      searchParams: {
        search: "",
        statusList: []
      },
      tagMap: [
      // 审批状态：0-待审批，1-已同意，2-已拒绝
      {
        type: "blue",
        text: $t("efsql3", "待审批")
      }, {
        type: "green",
        text: $t("e67793", "已同意")
      }, {
        type: "magenta",
        text: $t("e8vjx3", "已拒绝")
      }]
    };
  },
  computed: {
    columns() {
      const h = this.$createElement;
      return [{
        title: $t("hmxge3", "用户名"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        minWidth: 150,
        notShowSearch: true,
        tooltip: true,
        ellipsis: true
      }, {
        title: $t("cs1tti4", "所属单位"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "unitName",
        minWidth: 250,
        notShowSearch: true,
        tooltip: true,
        ellipsis: true
      }, {
        title: $t("haa72", "手机"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "mobile",
        minWidth: 180,
        align: "left",
        notShowSearch: true,
        renderTable: (h, {
          row
        }) => {
          return row.mobile ? h(TextMasker, {
            "key": `${row.detailId}-${row.mobile}`,
            "attrs": {
              "mask": row.mobile,
              "detailId": row.detailId
            }
          }) : row.mobile;
        }
      }, {
        title: $t("padf2", "邮箱"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "email",
        minWidth: 200,
        notShowSearch: true,
        renderTable: (h, {
          row
        }) => {
          return row.email ? h(TextMasker, {
            "key": `${row.detailId}-${row.email}`,
            "attrs": {
              "mask": row.email,
              "detailId": row.detailId,
              "type": "email"
            }
          }) : row.email;
        }
      }, {
        title: $t("k1e32", "状态"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "approveStatus",
        minWidth: 120,
        notShowSearch: true,
        renderTable: (h, {
          row
        }) => {
          const status = this.tagMap[row.approveStatus] || {
            type: "default",
            text: "—"
          };
          return h("Tag", {
            class: "apply-record-status-tag",
            props: {
              color: status.type
            }
          }, [h(OverflowTooltipText, {
            props: {
              text: status.text,
              maxWidth: 300,
              textClass: "apply-record-status-text",
              tooltipClass: "apply-record-status-tooltip",
              tooltipStyle: {
                display: "block",
                width: "100%",
                minWidth: 0
              }
            }
          })]);
        }
      }, {
        title: $t("lu6n73", "邀请人"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "inviteUser",
        minWidth: 100,
        renderTable: (h, {
          row
        }) => {
          return h("div", {
            "class": "text-left"
          }, [row.inviteUser]);
        },
        notShowSearch: true
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        align: "center",
        key: "action",
        minWidth: 160,
        renderTable: (h, {
          row
        }) => {
          let {
            approveStatus
          } = row;
          let renderMap = {
            0: h("div", {
              "class": "flex items-center gap-2 justify-center"
            }, [h("span", {
              "class": "text-[#2d8cf0] cursor-pointer",
              "attrs": {
                "type": "primary",
                "size": "small"
              },
              "on": {
                "click": () => {
                  this.approve(row.detailId, 1);
                }
              }
            }, [$t("ettv2", "同意")]), h("span", {
              "class": "text-[#2d8cf0] cursor-pointer",
              "attrs": {
                "type": "primary",
                "size": "small"
              },
              "on": {
                "click": () => {
                  this.approve(row.detailId, 2);
                }
              }
            }, [$t("hi6j2", "拒绝")])]),
            1: null,
            2: null
          };
          return renderMap[approveStatus];
        }
      }];
    },
    config() {
      return {
        //配置项
        autoFetch: false,
        columns: this.columns,
        table: {
          border: false,
          height: window.innerHeight - 305
        },
        // toolBarActions: this.toolBar,
        request: async params => {
          let {
            search,
            statusList
          } = this.searchParams;
          let {
            list,
            total,
            pageNum,
            pageSize
          } = (await this.getTableData({
            ...params,
            search,
            statusList: statusList.join(",")
          })) || {
            list: [],
            total: 0,
            pageNum: 0,
            pageSize: 10
          };
          return {
            list: list || [],
            total: Number(total) || 0,
            pageNum: pageNum || 0,
            pageSize: pageSize || 10
          };
        },
        map: {
          dataPath: "list",
          totalPath: "total",
          current: "pageNum",
          pageSize: "pageSize"
        },
        hide: {
          toolBar: true,
          search: true
        }
      };
    }
  },
  methods: {
    async getTableData(params) {
      let num = (params.pageNum - 1) * params.pageSize;
      let res = await request.inviteUserList({
        ...params,
        firstResult: num,
        inviteCode: this.inviteCode
      });
      let {
        retVal: {
          datas,
          pageSize,
          firstResult,
          totalRows
        }
      } = res;
      return {
        list: datas,
        total: totalRows,
        pageNum: firstResult / pageSize + 1,
        pageSize: pageSize
      };
    },
    async approve(detailId, approveStatus) {
      let {
        result,
        msg
      } = await request.approveInviteUserDetail({
        detailId,
        approveStatus
      });
      if (result === 0) {
        this.$Message.success(msg);
        this.$refs.tableRef.fetch();
      }
    },
    async refresh(invite) {
      this.inviteCode = invite.inviteCode;
      this.$refs.tableRef.fetch();
    },
    async query() {
      this.$refs.tableRef.searchAction();
    },
    resetParams() {
      this.searchParams = {
        search: "",
        statusList: []
      };
      this.$refs.tableRef.fetch();
    },
    async reset() {
      this.inviteCode = "";
      this.$refs.tableRef.fetch();
    }
  },
  mounted() {
    this.$refs.tableRef.fetch();
  }
};